export default "__VITE_ASSET__b8e344ab__"